import React, { Component } from 'react';
import { AuthUserContext, withAuthorization } from '../session';
import {capitalize, play_audio} from '../utils'
import GroupedLogList from '../components/GroupedLogList'
import {merge} from 'lodash'

class Analyze extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sona: null,
      analytics: {},
      expanded_keys: [],
      highlighted_key: null
    }

    this.value_listener = null
    this.child_listener = null
    this.action_listener = null
  }

  componentDidMount() {
    this.fetchAndListenForAnalyticsChanges()
    this.fetchSONA()
  }

  componentWillUnmount() {
    this.cancelListeners()
  }

  cancelListeners() {
    let sona_id = this.props.match.params.sona_id
    if (this.value_listener != null) this.props.firebase.sona_analytics(sona_id).off('value', this.value_listener)
    if (this.child_listener != null) this.props.firebase.sona_analytics(sona_id).off('child_changed', this.child_listener)
    if (this.action_listener != null) this.props.firebase.sona_analytics(sona_id + '/actions').off('child_changed', this.action_listener)
  }

  toggle_expanded(key) {
    let {expanded_keys} = this.state
    let key_idx = expanded_keys.indexOf(key)
    let in_list = key_idx > -1
    if (in_list) {
      expanded_keys.pop(key_idx)
    } else {
      expanded_keys.push(key)
    }
    this.setState({expanded_keys})
  }

  key_label(key) {
    const CUSTOM_FIELDS = ["Website", "Website2", "Website3", "extraImage", "extraImage2", "extraImage3"]
    let {sona} = this.state
    let label = {
      "heard": "Heard/Scanned"
    }[key]
    if (sona != null && CUSTOM_FIELDS.indexOf(key) > -1) {
      let sona_key = {
        "Website": "websitename",
        "Website2": "website2name",
        "Website3": "website3name",
        "extraImage": "extraImagename",
        "extraImage2": "extraImage2name",
        "extraImage3": "extraImage3name",
      }
      label = sona[sona_key[key]]
    }
    if (label == null) label = capitalize(key)
    return label
  }

  fetchSONA() {
    let sona_id = this.props.match.params.sona_id
    if (sona_id != null) {
      this.props.firebase.sona(sona_id).once('value', snapshot => {
        this.setState({sona: snapshot.val()})
      })
    }
  }

  flattenAnalytics(analytics) {
    if (analytics['actions'] != null) {
      merge(analytics, analytics['actions'])
      delete analytics['actions']
    }
    return analytics
  }

  fetchAndListenForAnalyticsChanges() {
    let {analytics} = this.state
    let sona_id = this.props.match.params.sona_id
    if (sona_id != null) {
      this.value_listener = this.props.firebase.sona_analytics(sona_id).on('value', (snapshot) => {
        let analytics = this.flattenAnalytics(snapshot.val())
        this.setState({analytics: analytics})
      });
      this.child_listener = this.props.firebase.sona_analytics(sona_id).on('child_changed', (snapshot) => {
        let child_key = snapshot.ref.key
        if (child_key !== "actions") {
          // Row to highlight is key one level deeper
          let val = snapshot.val()
          console.log(child_key)
          console.log(val)
          analytics[child_key] = val
          play_audio(process.env.PUBLIC_URL + '/sounds/complete.mp3')
          this.setState({highlighted_key: child_key, analytics: analytics})
        }
      })
      this.action_listener = this.props.firebase.sona_analytics(sona_id + '/actions').on('child_changed', (snapshot) => {
        let child_key = snapshot.ref.key
        analytics[child_key] = snapshot.val()
        play_audio(process.env.PUBLIC_URL + '/sounds/complete.mp3')
        this.setState({highlighted_key: child_key, analytics: analytics})
      })
    }
  }

  render_analytics_rows() {
    let {analytics, expanded_keys, highlighted_key} = this.state
    let rows = []
    Object.keys(analytics).forEach((key) => {
      let val = analytics[key]
      let timestamps = Object.keys(val)
      let count = timestamps.length
      let expanded = expanded_keys.indexOf(key) > -1
      let expanded_list
      let row_value
      if (expanded) {
        if (key === "votes") {
          let lis = row_value = Object.keys(val).map((vote_item) => {
            let votes = val[vote_item]
            return <li key={vote_item}><b>{ vote_item }</b>: { votes }</li>
          })
          expanded_list = (
            <div>
              <ul className="TimestampList">{lis}</ul>
              <a href="javascript:void(0)" onClick={this.toggle_expanded.bind(this, key)}>Hide</a>
            </div>
          )
        } else {
          expanded_list = (
            <div>
              <GroupedLogList logs={val} />
              <a href="javascript:void(0)" onClick={this.toggle_expanded.bind(this, key)}>Hide</a>
            </div>
          )
        }
      }
      row_value = (
        <div>
          <b>{ count }</b> <span hidden={expanded}><a href="javascript:void(0)" onClick={this.toggle_expanded.bind(this, key)}><i className="fa fa-list"></i></a></span>
          { expanded_list }
        </div>
      )
      let highlighted = highlighted_key == key
      let cls = "StatRow"
      if (highlighted) cls += " Highlight"
      rows.push(
        <tr key={key} data-key={key} className={cls}>
          <th className="StatLabel">
            { this.key_label(key) }
          </th>
          <td>
            { row_value }
          </td>
        </tr>
      )
    })
    return rows
  }

  print() {
    window.print()
  }

  export() {
    let {analytics, sona} = this.state
    let sona_name = sona == null ? "unknown" : sona.name
    let date = new Date();
    let rows = [
      ["SONA", sona_name],
      ["SONA Analytics Report"],
      ["Date", date.toLocaleDateString()],
      ["Time", date.toTimeString()],
      ["SONA ANALYTICS", "Interactions", "Email"]
    ]
    Object.keys(analytics).forEach((key) => {
      let val = analytics[key]
      let timestamps = Object.keys(val)
      let label = this.key_label(key)
      let expanded_list
      if (key === "votes") {
        expanded_list = Object.keys(val).map((vote_item) => {
          let votes = val[vote_item]
          return [`${ vote_item }: ${ votes }`]
        })
      } else {
        expanded_list = timestamps.map((ts) => {
          let email = val[ts][1]
          return [ts, email]
        })
      }
      expanded_list.forEach((li) => {
        rows.push([label, li[0], li[1]])
      })
    })
    let csvContent = "data:application/csv;charset=utf-8,"
        + encodeURI(rows.map(e => e.join(",")).join("\n"));

    var link = document.createElement('a');
    link.download = sona_name + ".csv";
    link.target = "_blank"
    link.href = csvContent;
    link.click();
  }

  render() {
    let {sona} = this.state
    let date = new Date()
    let sona_name = "--"
    if (sona != null) sona_name = sona.name
    return (
      <AuthUserContext.Consumer>
        {(ctx) => {
          return (
            <div>
              <img
                className="Create-logo"
                src={process.env.PUBLIC_URL + '/img/logo.png'}
                alt="logo"
              />
              <h1 className="title">SONA: { sona_name }</h1>
              <h2 className="Create-title">SONA Analytics Report</h2>
              <h4>Date: { date.toLocaleDateString() }</h4>
              <h4>Time: { date.toTimeString() }</h4>

              <table className="AnalyticsTable">
                <tbody>
                <tr>
                  <th>Stat</th>
                  <th>Count</th>
                </tr>
                { this.render_analytics_rows() }
                </tbody>
              </table>

              <button className="BigButton" onClick={this.export.bind(this)}>Export CSV</button> &nbsp;
              <button className="BigButton" onClick={this.print.bind(this)}>Print</button>
            </div>
          )
        }}
      </AuthUserContext.Consumer>
      )

  }
}

const condition = authUser => !!authUser;
export default withAuthorization(condition)(Analyze);
